/**
 * ISO 3166-2
 */
export enum CountryEnum {
  ITALY = 'IT',
  UNITED_KINGDOM = 'GB',
  GREECE = 'GR'
}
